import React from 'react'
import { CircularProgress } from '@mui/material'
import { styled } from '@mui/material/styles'

const Root = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '80vh',
}))

export default function PageLoading() {
  return (
    <Root data-testid="page-loader">
      <CircularProgress />
    </Root>
  )
}
